import React, {useState, useEffect} from "react";
import Pager from "./components/Pager";
import {Input} from "../../styles/Forms";
import {Grid} from "../../styles/Grid";
import {
   ViewTableStyled,
   HeadViewTable,
   BodyViewTable,
   FooterViewTable,
   TableStyled,
   THeadStyled,
   TBodyStyled,
   NoDataComponent,
   DivItem,
   ThStyled,
   TdStyled,
} from "./components/TableStyles";
import {EditButton, DeleteButton, SeeButton, ShowButton, ToggleButton, ActivateButton} from "./components/Actions";
import {ReactComponent as DropIcon} from "../../assets/icons/double_arrow.svg";
import propTypes from "prop-types";
import {filterSearch} from "../../hooks/helpers";

export default function Table({columns, data, theme, showModal, editModal, deleteModal, noDataText, toggleChange, viewAction}) {
   const [currentPage, setCurrentPage] = useState(1);
   const [pageLength, setPageLength] = useState(10);
   const [filteredData, setFilteredData] = useState(data); // los datos a mostrar por página
   const [visibleData, setVisibleData] = useState([]); // los datos a mostrar por página
   const [orderTag, setOrderTag] = useState({reverse: false, order: "id"});
   const [searchVal, setSearchVal] = useState("");

   useEffect(() => {
      applyFilters();
   }, [orderTag, data, searchVal]);

   useEffect(() => {
      selectVisibleData();
   }, [currentPage, pageLength, orderTag, filteredData, data]);

   const updatePage = (e) => {
      e.preventDefault();
      const newVal = e.target.value;
      if (newVal < 10) return false;
      setPageLength(Number(newVal));
      setCurrentPage(1);
   };

   const applyFilters = () => {
      // filtrar
      let currentData = [...data];
      let filt = searchVal.length > 2 ? currentData.filter((item) => filterSearch(searchVal, item)) : currentData;
      // ordernar
      let newFiltered = orderDataByTag(filt, orderTag);
      setFilteredData(newFiltered);
   };

   function selectVisibleData() {
      // index inicial
      let start = (currentPage - 1) * pageLength;
      // index final
      let end = start + pageLength - 1;
      if (end > filteredData.length + pageLength) return false;
      const newVisible = filteredData.filter((item, index) => index >= start && index <= end);
      setVisibleData(newVisible);
   }

   const updateCurrent = (num) => {
      setCurrentPage(num);
   };

   const orderBy = (val) => {
      let ordetTagN = {
         reverse: val === orderTag.order ? !orderTag.reverse : false,
         order: val,
      };
      setOrderTag(ordetTagN);
   };

   /* const searchVal = e => {
       const val = e.target.value;
      if (val.length < 2) return false;
       let currentData = [...data];
      let filt = currentData.filter(item => filterSearch(val, item));
      setFilteredData(filt);
   }; */

   if (!columns) return null;
   if (data.length === 0) return <NoDataComponent theme={theme}>{noDataText || "No se encontraron datos"}</NoDataComponent>;
   return (
      <ViewTableStyled>
         <HeadViewTable>
            <Grid className="length">
               Show
               <Input type="number" name="max" min={10} onChange={updatePage} defaultValue={pageLength} />
               Entries
            </Grid>
            <Grid className="searcher">
               Buscar:
               <Input type="search" onChange={(e) => setSearchVal(e.target.value)} />
            </Grid>
         </HeadViewTable>
         {filteredData.length === 0 ? (
            <NoDataComponent theme={theme}>{"No hay coincidencias con la busqueda"}</NoDataComponent>
         ) : (
            <BodyViewTable>
               <TableStyled>
                  <THeadStyled>
                     <tr>
                        {React.Children.toArray(
                           columns.map((colHead) => {
                              return (
                                 <ThStyled className={colHead.class || "normal"} tdWidth={colHead.width} tdMax={colHead.maxWidth}>
                                    <div
                                       onClick={() => {
                                          if (colHead.accessor) {
                                             orderBy(colHead.accessor);
                                          }
                                       }}
                                    >
                                       {colHead.title}
                                       <span>{!colHead.component && <DropIcon width="0.6em" height="1em" fill="#69799e" />}</span>
                                    </div>
                                 </ThStyled>
                              );
                           }),
                        )}
                     </tr>
                  </THeadStyled>
                  <TBodyStyled>
                     {React.Children.toArray(
                        visibleData.map((itemData) => {
                           return (
                              <tr>
                                 {React.Children.toArray(
                                    columns.map((col) => {
                                       if (col.component) {
                                          return ButtonsSection(deleteModal, toggleChange, itemData, col, editModal, showModal, viewAction);
                                       }
                                       return (
                                          <TdStyled className={col.class || "normal"} tdWidth={col.width} tdMax={col.maxWidth}>
                                             <DivItem
                                                tdWidth={col.width}
                                                tdMax={col.maxWidth}
                                                className={col.action ? "actionable" : ""}
                                                onClick={() => {
                                                   if (col.action) {
                                                      showModal(itemData);
                                                   }
                                                }}
                                             >
                                                {itemData[col.accessor]}
                                             </DivItem>
                                          </TdStyled>
                                       );
                                    }),
                                 )}
                                 {/* <td className="actionBtn ghost">Ed</td> */}
                              </tr>
                           );
                        }),
                     )}
                  </TBodyStyled>
               </TableStyled>
            </BodyViewTable>
         )}

         <FooterViewTable>
            <Pager max={data.length} current={currentPage} pageLength={pageLength} updatePage={updateCurrent} />
         </FooterViewTable>
      </ViewTableStyled>
   );
}

Table.protTypes = {
   deleteModal: propTypes.func,
   editModal: propTypes.func,
   showModal: propTypes.func,
   data: propTypes.object,
   columns: propTypes.object.isRequired,
};

function orderDataByTag(data, order) {
   // filteredData orderTag
   if (order.reverse) {
      return data.reverse();
   }
   function compare(a, b) {
      let itemA = typeof a[order.order] === "string" ? a[order.order].toLowerCase() : a[order.order];
      let itemB = typeof b[order.order] === "string" ? b[order.order].toLowerCase() : b[order.order];
      let comparison = 0;
      if (itemA > itemB) {
         comparison = 1;
      } else if (itemA < itemB) {
         comparison = -1;
      }
      return comparison;
   }

   const toReturn = data.sort(compare);
   return toReturn;
}

const ButtonsSection = (deleteModal, toggleChange, itemData, col, editModal, showModal, viewAction) => {
   // let Button;
   switch (col.component) {
      case "delete":
         return (
            <DeleteButton
               action={() => {
                  if (deleteModal) {
                     deleteModal(itemData);
                  }
               }}
            />
         );
      case "disable":
         return (
            <>
               {itemData[col.accessor] ? (
                  <DeleteButton
                     action={() => {
                        if (deleteModal) {
                           deleteModal(itemData);
                        }
                     }}
                  />
               ) : (
                  <ActivateButton
                     action={() => {
                        if (deleteModal) {
                           deleteModal(itemData);
                        }
                     }}
                  />
               )}
            </>
         );
      case "toggle":
         return (
            <ToggleButton
               status={itemData[col.accessor]}
               action={() => {
                  if (toggleChange) {
                     toggleChange(itemData);
                  }
               }}
            />
         );
      case "edit":
         return (
            <EditButton
               action={() => {
                  if (editModal) {
                     editModal(itemData);
                  }
               }}
            />
         );
      case "show":
         return (
            <ShowButton
               action={() => {
                  if (showModal) {
                     showModal(itemData);
                  }
               }}
            />
         );
      case "view":
         return (
            <SeeButton
               action={() => {
                  if (viewAction) {
                     viewAction(itemData);
                  }
               }}
            />
         );
      default:
         return (
            <SeeButton
               action={() => {
                  if (showModal) {
                     showModal(itemData);
                  }
               }}
            />
         );
   }
   // return
};
